<template>
  <!-- 智能硬件系统 -->
  <div class="hardware">
    <div class="box">
      <div class="header">
        <div class="title">智能硬件系统</div>
        <div class="border"></div>
      </div>
      <div class="body">
        <div class="center">
          <div class="title">打破硬件信息孤岛 实现场景化联动</div>
          <div class="text">
            通过对智能硬件的深度整合、统一管控，运用先进的互联网云技术、物联网技术，打造信息化、数字化、智能化、平台化的云数据管理平台，帮助物业建立安全、高效、智能、便利的智慧化新社区
          </div>
          <div class="flex-list">
            <div class="flex">
            <img :src="yesLogo" alt="" />
            <div>一体化服务</div>
          </div>
          <div class="flex">
            <img :src="yesLogo" alt="" />
            <div>场景化联动</div>
          </div>
          <div class="flex">
            <img :src="yesLogo" alt="" />
            <div>智能云服务</div>
          </div>
          </div>
        </div>

        <div class="left">
          <div class="list">
            <router-link
              class="item"
              v-for="item in hardwareLeftList"
              :key="item.id"
              :style="`background-image: url(${item.open});`"
              :to="item.path"
            >
              <img class="logo" :src="item.logo" alt="" />
              <div class="title">{{ item.title }}</div>
              <div class="more">
                <div>了解更多</div>
                <img :src="mobilemore" alt="" />
              </div>
            </router-link>
          </div>
        </div>

        <div class="right">
          <div class="list">
            <router-link
              class="item"
              v-for="item in hardwareRightList"
              :key="item.id"
              :style="`background-image: url(${item.open});`"
              :to="item.path"
            >
              <img class="logo" :src="item.logo" alt="" />
              <div class="title">{{ item.title }}</div>
              <div class="more">
                <div>了解更多</div>
                <img :src="mobilemore" alt="" />
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobilehardware1 from "../../../assets/home/mobilehardware1.png";
import mobilehardware2 from "../../../assets/home/mobilehardware2.png";
import mobilehardware3 from "../../../assets/home/mobilehardware3.png";
import mobilehardware4 from "../../../assets/home/mobilehardware4.png";
import mobilehardware5 from "../../../assets/home/mobilehardware5.png";
import mobilehardware6 from "../../../assets/home/mobilehardware6.png";
import mobilehardware7 from "../../../assets/home/mobilehardware7.png";
import mobilehardware8 from "../../../assets/home/mobilehardware8.png";

import hardwareClose from "../../../assets/home/hardwareClose.png";

import mobilehardwareOpen1 from "../../../assets/home/mobilehardwareOpen1.png";
import mobilehardwareOpen2 from "../../../assets/home/mobilehardwareOpen2.png";
import mobilehardwareOpen3 from "../../../assets/home/mobilehardwareOpen3.png";
import mobilehardwareOpen4 from "../../../assets/home/mobilehardwareOpen4.png";
import mobilehardwareOpen5 from "../../../assets/home/mobilehardwareOpen5.png";
import mobilehardwareOpen6 from "../../../assets/home/mobilehardwareOpen6.png";
import mobilehardwareOpen7 from "../../../assets/home/mobilehardwareOpen7.png";
import mobilehardwareOpen8 from "../../../assets/home/mobilehardwareOpen8.png";

import yesLogo from "../../../assets/home/yesLogo.png";

import mobilemore from "../../../assets/home/mobilemore.png";

export default {
  setup() {
    return reactive({
      mobilemore: mobilemore,
      hardwareClose: hardwareClose,
      hardwareLeftList: [
        {
          id: 1,
          title: "智能门禁",
          open: mobilehardwareOpen1,
          logo: mobilehardware1,
          path: "/mobile/programme/accesscontrol",
          children: [
            {
              id: 1,
              title: "一键开门",
            },
            {
              id: 2,
              title: "人脸识别",
            },
            {
              id: 3,
              title: "访客邀约",
            },
          ],
        },
        {
          id: 2,
          title: "智能监控",
          open: mobilehardwareOpen2,
          logo: mobilehardware2,
          path: "/mobile/programme/monitor",
          children: [
            {
              id: 1,
              title: "远程监控",
            },
            {
              id: 2,
              title: "防御报警",
            },
            {
              id: 3,
              title: "视频回放",
            },
          ],
        },
        {
          id: 3,
          title: "智能充电",
          open: mobilehardwareOpen3,
          logo: mobilehardware3,
          path: "/mobile/programme/charge",
          children: [
            {
              id: 1,
              title: "智能充电",
            },
            {
              id: 2,
              title: "在线充值",
            },
            {
              id: 3,
              title: "实时计费",
            },
          ],
        },
        {
          id: 4,
          title: "智能家居",
          open: mobilehardwareOpen4,
          logo: mobilehardware4,
          path: "/mobile/programme/homefurnishing",
          children: [
            {
              id: 1,
              title: "智能操控",
            },
            {
              id: 2,
              title: "一键启动",
            },
            {
              id: 3,
              title: "安全省心",
            },
          ],
        },
      ],
      hardwareRightList: [
        {
          id: 1,
          title: "智能能耗",
          open: mobilehardwareOpen5,
          logo: mobilehardware5,
          path: "/mobile/programme/energyconsumption",
          children: [
            {
              id: 1,
              title: "远程抄表",
            },
            {
              id: 2,
              title: "在线缴费",
            },
            {
              id: 3,
              title: "负荷预警",
            },
          ],
        },
        {
          id: 2,
          title: "智能梯控",
          open: mobilehardwareOpen6,
          logo: mobilehardware6,
          path: "/mobile/programme/laddercontrol",
          children: [
            {
              id: 1,
              title: "限次管理",
            },
            {
              id: 2,
              title: "智能识别",
            },
            {
              id: 3,
              title: "分区域管理",
            },
          ],
        },
        {
          id: 3,
          title: "智能停车",
          open: mobilehardwareOpen7,
          logo: mobilehardware7,
          path: "/mobile/programme/parking",
          children: [
            {
              id: 1,
              title: "高峰畅行",
            },
            {
              id: 2,
              title: "一键挪车",
            },
            {
              id: 3,
              title: "智能识别车牌",
            },
          ],
        },
        {
          id: 4,
          title: "楼宇对讲",
          open: mobilehardwareOpen8,
          logo: mobilehardware8,
          path: "/mobile/programme/intercom",
          children: [
            {
              id: 1,
              title: "安全智能",
            },
            {
              id: 2,
              title: "音质清晰",
            },
            {
              id: 3,
              title: "一键开启可视对讲",
            },
          ],
        },
      ],
      yesLogo: yesLogo,
    });
  },
};
</script>

<style scoped>
.hardware {
  background: linear-gradient(315deg, #122437 0%, #213d5b 100%);
  padding: 16px 0;
  margin-top: 24px;
}
.box {
  width: 92vw;
  margin: 0 auto;
}
.header .title {
  font-size: 16px;
  text-align: center;
  color: #fff;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 5px auto 0;
}

.body .left .list,
.body .right .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.body .left .list .item,
.body .right .list .item {
  width: 165px;
  height: 156px;
  text-align: center;
  background: linear-gradient(225deg, #203c59 0%, #111f2e 100%);
  box-shadow: 20px 20px 20px 1px rgba(16, 18, 23, 0.2);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-decoration: none;
  margin-top: 37px;
  position: relative;
  background-position: center;
}
.body .left .list .item .logo,
.body .right .list .item .logo {
  width: 42px;
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
}
.body .left .list .item .title,
.body .right .list .item .title {
  font-size: 16px;
  color: #fff;
  margin-top: 33px;
}
.body .left .list .item .text,
.body .right .list .item .text {
  font-size: 14px;
  color: #d1e8ff;
  margin-top: 10px;
}
.body .left .list .item .more,
.body .right .list .item .more {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #fff;
  margin-top: 69px;
}
.body .left .list .item .more img,
.body .right .list .item .more img {
  width: 12px;
  margin-left: 8px;
}

.body .center {
  width: 92vw;
  margin: 0 auto 0;
  padding-top: 16px;
  margin-bottom: 16px;
}
.body .center .title {
  text-align: center;
  font-size: 16px;
  color: #f0f0f0;
}
.body .center .text {
  margin: 18px auto 0;
  font-size: 12px;
  color: #d1e8ff;
}
.flex-list {
  display: flex;
}
.body .center .flex {
  margin: 0 auto;
  display: flex;
  align-items: center;
  margin-top: 18px;
}
.body .center .flex img {
  width: 16px;
  margin-right: 8px;
}
.body .center .flex div {
  font-size: 10px;
  color: #d1e8ff;
}
</style>
